import _defineProperty from "@babel/runtime/helpers/defineProperty";
//
// Copyright IBM Corp. 2020, 2021
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { pkg } from '../../settings';
import { Button } from 'carbon-components-react';
var componentName = 'CardHeader';
var defaults = {
  hasActions: false,
  titleSize: 'default'
};
export var CardHeader = function CardHeader(_ref) {
  var _cx;

  var actions = _ref.actions,
      noActionIcons = _ref.noActionIcons,
      onPrimaryButtonClick = _ref.onPrimaryButtonClick,
      primaryButtonIcon = _ref.primaryButtonIcon,
      primaryButtonPlacement = _ref.primaryButtonPlacement,
      primaryButtonText = _ref.primaryButtonText,
      description = _ref.description,
      _ref$hasActions = _ref.hasActions,
      hasActions = _ref$hasActions === void 0 ? defaults.hasActions : _ref$hasActions,
      label = _ref.label,
      title = _ref.title,
      _ref$titleSize = _ref.titleSize,
      titleSize = _ref$titleSize === void 0 ? defaults.titleSize : _ref$titleSize;
  var blockClass = "".concat(pkg.prefix, "--card");
  var headerClass = "".concat(blockClass, "__header");
  var headerClasses = cx(headerClass, (_cx = {}, _defineProperty(_cx, "".concat(headerClass, "-label-only"), label && !title && !description), _defineProperty(_cx, "".concat(headerClass, "-has-label"), !!label), _defineProperty(_cx, "".concat(blockClass, "__title-lg"), titleSize === 'large'), _cx));
  var actionGhostButton = "".concat(blockClass, "__actions-header-ghost-button");
  var actionGhostButtonClass = cx(actionGhostButton, _defineProperty({}, "".concat(actionGhostButton, "--only"), noActionIcons));
  return /*#__PURE__*/React.createElement("div", {
    className: headerClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(headerClass, "-container")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "__title-container")
  }, label && /*#__PURE__*/React.createElement("p", {
    className: "".concat(blockClass, "__label")
  }, label), title && /*#__PURE__*/React.createElement("h6", {
    className: "".concat(blockClass, "__title")
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: "".concat(blockClass, "__description")
  }, description)), hasActions && /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "__actions ").concat(blockClass, "__actions-header")
  }, actions, primaryButtonText && primaryButtonPlacement === 'top' && /*#__PURE__*/React.createElement(Button, {
    kind: "ghost",
    size: "small",
    renderIcon: primaryButtonIcon,
    onClick: onPrimaryButtonClick,
    className: actionGhostButtonClass
  }, primaryButtonText))));
};
CardHeader.propTypes = {
  actions: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  description: PropTypes.string,
  hasActions: PropTypes.bool,
  label: PropTypes.string,
  noActionIcons: PropTypes.bool,
  onPrimaryButtonClick: PropTypes.func,
  primaryButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  primaryButtonPlacement: PropTypes.oneOf(['top', 'bottom']),
  primaryButtonText: PropTypes.string,
  title: PropTypes.string,
  titleSize: PropTypes.oneOf(['default', 'large'])
};
CardHeader.displayName = componentName;